export default __webpack_public_path__ + "static/media/Mobooks.57768d38.png";